<ul class="w-full select-none p-0 text-xl">
  <mat-radio-group [formControl]="formControl" (keydown.enter)="onKeydownEnter()">
    @for (option of optionsEntries(); track option[0]) {
      <li (click)="select(option[1])" class="flex list-none flex-row">
        <mat-radio-button [value]="option[1]"></mat-radio-button>
        <span class="p-1">
          {{ option[0] }}
        </span>
      </li>
    }
  </mat-radio-group>
</ul>
